export const chartDataTypes = {
  VISITORS: 'visitors',
  INCIDENTS: 'incidents',
  INITIATIVES: 'initiatives',
}
